export const CRM_ADVISOR_TOOLS_ENABLED = (
  process.env.REACT_APP_ENABLE_CRM_ADVISOR_TOOLS || 'false'
).toLowerCase() === 'true';

export const CRM_ADVISOR_INSIGHTS_ENABLED = (
  process.env.REACT_APP_ENABLE_CRM_ADVISOR_INSIGHTS || 'false'
).toLowerCase() === 'true';
